import React from 'react';
import { Link } from 'gatsby';

import Icon from '~/components/modules/icon';
import Button from '~/components/modules/button';

import HealthyDelawareIcon from '~/images/inline/healthy-delaware-icon.svg';
import HealthyDelaware from '~/images/inline/healthy-delaware.svg';

const YrbsNavbar = ({
	hasNavigation = true,
	toolkitTitle,
	toolkitLogo,
	toolkitUrl
}) => {
	return (
		<div className="container flex flex-wrap justify-between items-center mx-auto px-4 py-2">
			<div className="flex items-center lg:basis-full lg:mb-4">
				<p className="mr-2 font-bold text-xs text-gray-450 hidden lg:block">Back to</p>
				<a
					href="https://www.healthydelaware.org/community-partners/toolkits"
					className="inline-flex items-center gap-2"
				>
					<span className="sr-only">HealthyDelaware.org</span>
					<HealthyDelawareIcon
						className="h-6 lg:h-4 text-emerald-650"
						aria-hidden="true"
						role="img"
					/>
					<HealthyDelaware
						className="h-2.5 text-gray-450 hidden lg:block"
						aria-hidden="true"
						role="img"
					/>
				</a>
			</div>

			{hasNavigation &&
				<>
					<div
						className={`
							grow
							${!toolkitLogo ? 'basis-0' : 'justify-self-center grow-0'}
						`}
					>
						<Link
							to={toolkitUrl}
							className="relative uppercase text-center lg:text-left text-indigo-950 transition-colors hover:text-indigo-800 focus:text-indigo-800 no-underline"
						>
							{toolkitTitle &&
								<h1
									className="font-black text-lg md:text-2xl"
								>
									<Icon
										iconImage="mdi:home"
										sizeClasses="w-5 h-5 md:w-[1.8rem] md:h-[1.8rem]"
										className="inline-block align-text-bottom"
									/>
									{toolkitTitle}
								</h1>
							}
							{toolkitLogo && toolkitLogo}
						</Link>
					</div>

					<Button
						as="scroll"
						to="contact"
						variant="secondary"
						size="sm"
					>
						Contact us
					</Button>
				</>
			}
		</div>
	);
};

export default YrbsNavbar;
